<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-update`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46.488 37a9.004 9.004 0 01-16.976 0l4.489.001A4.992 4.992 0 0038 39a4.992 4.992 0 004-1.999h4.488zM28 6c9.62 0 17.477 7.546 17.975 17.042h-4.007C41.475 15.757 35.41 10 28 10a14.007 14.007 0 00-13.312 9.65l-.673 2.06-2.094.562A8.005 8.005 0 006 30a8 8 0 008 8h10.817l3.838 3.988A18.26 18.26 0 0128 42H14C7.373 42 2 36.627 2 30c0-5.55 3.768-10.22 8.886-11.592C13.238 11.205 20.01 6 28 6zm16.71 27.095l3.232 3.535a.231.231 0 010 .307.19.19 0 01-.14.063h-6.604c-.11 0-.198-.097-.198-.217 0-.057.02-.112.058-.153l3.232-3.535a.28.28 0 01.42 0zM38 25a9.003 9.003 0 018.777 7h-4.193a5.001 5.001 0 00-9.168 0h.886a.19.19 0 01.14.063.232.232 0 01.037.25l-.037.057-3.232 3.535a.278.278 0 01-.366.047l-.054-.047-3.232-3.535a.227.227 0 01-.058-.153c0-.1.062-.184.145-.21l.053-.007h1.525c.91-4.008 4.494-7 8.777-7z"/></svg>
</template>
<script>

export default {
  name: 'IconCloudUpdate',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
